import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Calendar, Users, Mail, Heart, MessageSquare, Briefcase } from "lucide-react";

const CARDS = [
  { key: "events", label: "Events", icon: Calendar, path: "events" },
  { key: "services", label: "Services", icon: Briefcase, path: "services" },
  { key: "imams", label: "Imams", icon: Users, path: "imams" },
  { key: "newsletter", label: "Subscribers", icon: Mail, path: "admin/newsletter" },
  { key: "messages", label: "Messages", icon: MessageSquare, path: "admin/messages" },
];

export default function AdminOverview() {
  const [counts, setCounts] = useState({});
  const [summary, setSummary] = useState({ total: 0, count: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [evs, svs, ims, subs, msgs, ds] = await Promise.all([
          api.get("/admin/events/"), api.get("/admin/services/"), api.get("/admin/imams/"),
          api.get("/admin/newsletter"), api.get("/admin/messages"), api.get("/admin/donations/summary"),
        ]);
        setCounts({
          events: evs.data.length,
          services: svs.data.length,
          imams: ims.data.length,
          newsletter: subs.data.length,
          messages: msgs.data.length,
        });
        setSummary(ds.data);
      } catch {}
    })();
  }, []);

  return (
    <div data-testid="admin-overview">
      <div className="mb-10">
        <div className="text-[10px] uppercase tracking-[0.22em] text-gold font-semibold">Dashboard</div>
        <h1 className="font-serif text-4xl mt-2 text-ink">Welcome back</h1>
        <p className="mt-2 text-ink/60">A quick look at your community's activity.</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        <div className="rounded-3xl bg-emerald_deep text-cream p-8 relative overflow-hidden">
          <div className="absolute inset-0 pattern-girih opacity-20" />
          <div className="relative">
            <div className="text-[10px] uppercase tracking-[0.22em] text-gold">Total donations received</div>
            <div className="font-serif text-5xl mt-3">${summary.total.toFixed(2)}</div>
            <div className="mt-2 text-sm text-cream/70">{summary.count} successful transaction{summary.count !== 1 ? "s" : ""}</div>
          </div>
        </div>
        {CARDS.map((c) => (
          <div key={c.key} className="rounded-3xl bg-white border border-sand p-7">
            <div className="flex items-center justify-between">
              <div className="w-10 h-10 rounded-xl bg-emerald_deep/10 text-emerald_deep flex items-center justify-center">
                <c.icon size={18} />
              </div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-gold">{c.label}</div>
            </div>
            <div className="font-serif text-4xl mt-5 text-ink">{counts[c.key] ?? "—"}</div>
          </div>
        ))}
      </div>

      <div className="rounded-3xl bg-white border border-sand p-8">
        <h2 className="font-serif text-2xl text-ink">Quick tips</h2>
        <ul className="mt-4 space-y-2 text-sm text-ink/70 list-disc list-inside">
          <li>Update <strong>Iqamah Times</strong> whenever your schedule shifts.</li>
          <li>Add new <strong>Events</strong> and toggle "published" to control visibility.</li>
          <li>Export newsletter subscribers as CSV from the Newsletter page.</li>
          <li>Site settings (address, phone, email, social links) can be changed from <strong>Site Settings</strong>.</li>
        </ul>
      </div>
    </div>
  );
}
